import { ReactComponent as duplicateSVG } from '../../../../../assets/svg/invoices-icons/icon-duplicate-action.svg';
import { ReactComponent as cancelSVG } from '../../../../../assets/icons/svg/shared/ic-shared-trash.svg';

export const BILL_ACTIONS = {
  PAY_NOW: 'PAY_NOW',
  MARK_AS_PAID: 'MARK_AS_PAID',
  MARK_AS_UNPAID: 'MARK_AS_UNPAID',
  DUPLICATE: 'DUPLICATE',
  CANCEL: 'CANCEL',
  REMINDER_ON: 'REMINDERS_ON',
  REMINDER_OFF: 'REMINDERS_OFF',
  PREVIEW: 'PREVIEW',
  CANCEL_DETAILS_REQUEST: 'CANCEL_DETAILS_REQUEST',
} as const;

export const BILL_ACTIONS_TEXTS = {
  PAY_NOW: 'BILL_PAY.BILL_ACTIONS.PAY_NOW',
  MARK_AS_PAID: 'BILL_PAY.BILL_ACTIONS.MARK_AS_PAID',
  CANCEL_DETAILS_REQUEST: 'BILL_PAY.BILL_ACTIONS.CANCEL_DETAILS_REQUEST',
  MARK_AS_UNPAID: 'BILL_PAY.BILL_ACTIONS.MARK_AS_UNPAID',
  DUPLICATE: 'BILL_PAY.BILL_ACTIONS.DUPLICATE',
  DELETE: 'BILL_PAY.BILL_ACTIONS.DELETE',
  REMINDER_ON: 'BILL_PAY.BILL_ACTIONS.REMINDER_ON',
  REMINDER_OFF: 'BILL_PAY.BILL_ACTIONS.REMINDER_OFF',
  REMINDER_DESCRIPTION: 'BILL_PAY.BILL_ACTIONS.REMINDER_DESCRIPTION',
} as const;

export const PRIMARY_ACTIONS_MAPPING_BY_STATUS = {
  PENDING: [
    {
      name: BILL_ACTIONS.PAY_NOW, title: BILL_ACTIONS_TEXTS.PAY_NOW, SVGIcon: '', width: '', key: 'button_pay_now',
    },
    {
      name: BILL_ACTIONS.MARK_AS_PAID, title: BILL_ACTIONS_TEXTS.MARK_AS_PAID, SVGIcon: '', width: '', key: 'button_mark_as_paid',
    }],
  WAITING_DETAILS: [
    {
      name: BILL_ACTIONS.DUPLICATE, title: BILL_ACTIONS_TEXTS.DUPLICATE, SVGIcon: duplicateSVG, width: '', key: 'button_duplicate',
    },
    {
      name: BILL_ACTIONS.CANCEL_DETAILS_REQUEST, title: BILL_ACTIONS_TEXTS.CANCEL_DETAILS_REQUEST, SVGIcon: '', width: 'w-[270px]', key: 'button_cancel_request',
    }],
  PAID: [
    {
      name: BILL_ACTIONS.DUPLICATE, title: BILL_ACTIONS_TEXTS.DUPLICATE, SVGIcon: duplicateSVG, width: '', key: 'button_duplicate',
    },
    {
      name: BILL_ACTIONS.MARK_AS_UNPAID, title: BILL_ACTIONS_TEXTS.MARK_AS_UNPAID, SVGIcon: '', width: '', key: 'button_mark_as_unpaid',
    }],
};

const SECONDARY_ACTION_DUPLICATE = {
  name: BILL_ACTIONS.DUPLICATE,
  title: BILL_ACTIONS_TEXTS.DUPLICATE,
  SVGIcon: duplicateSVG,
  key: 'button_duplicate',
};

const SECONDARY_ACTION_CANCEL = {
  name: BILL_ACTIONS.CANCEL,
  title: BILL_ACTIONS_TEXTS.DELETE,
  SVGIcon: cancelSVG,
  key: 'button_cancel',
};

export const SECONDARY_ACTIONS_MAPPING_BY_STATUS = {
  PENDING: [
    SECONDARY_ACTION_DUPLICATE,
    SECONDARY_ACTION_CANCEL],
  PAID: [SECONDARY_ACTION_CANCEL],
};
